var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('div',{staticClass:"card light"},[_c('div',{staticClass:"content h-stretch"},[_c('form',{staticClass:"gap-3 h-stretch"},[_c('label',{staticClass:"text-left required"},[_vm._v("From date:")]),_c('InputDatePicker',{model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c('label',{staticClass:"text-left required"},[_vm._v("Amount:")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.monthly),expression:"monthly"}],attrs:{"type":"number"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.monthly=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.monthlyRates),function(rate){return _c('option',{key:rate},[_vm._v(" "+_vm._s(rate)+" ")])}),0),_c('label',{staticClass:"text-left"},[_vm._v("Hourly Pay")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hourly),expression:"hourly"}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.hourly)},on:{"input":function($event){if($event.target.composing)return;_vm.hourly=$event.target.value}}}),_c('div',{staticClass:"h-stack h-end"},[_c('button',{staticClass:"submit",on:{"click":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_vm._v("Submit")])])],1)])]),_c('a',{staticClass:"heading-title-2"},[_vm._v("History")]),_c('Table',{attrs:{"items":_vm.pay,"defaultColumn":0,"columns":[
      {
        name: 'Date',
        sort: 'date',
        path: ['date'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Created By',
        sort: 'alphabet',
        path: ['createdBy', 'fullName'],
      },
      {
        name: 'Pay',
        sort: 'numeric',
        path: ['amount'],
        formatMap: (amount) =>
          `${Math.round(amount)} Kč/hod (${
            Math.round((amount * 8 * 252) / 12 / 1000) * 1000
          } Kč/měsíc)`,
      },
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }